import ContactForm from '@/components/forms/ContactForm/ContactForm';

interface ContactFormBlockProps {
	data: any;
	blockId: string;
}

export default function ContactFormBlock({ blockId, data }: ContactFormBlockProps) {
	const introContent = data?.intro_content;
	const showIntro = data?.show_intro ?? false;
	const showForm = data?.show_form ?? true;

	return (
		<section id={blockId} className="pb-16 md:pb-24 pt-0 bg-gray-50">
			<ContactForm introContent={introContent} showIntro={showIntro} showForm={showForm} />
		</section>
	);
}
